<script>
import Navbar from "@/components/navbar";
import Features from "@/components/features";
import Services from "@/components/services";
import About from "@/components/about";
import Pricing from "@/components/pricing";
import Testimonial from "@/components/testimonial";
import GetStarted from "@/components/getstarted";
import Blog from "@/components/blog";
import Contact from "@/components/contact";
import Footer from "@/components/footer";

/**
 * Index-1 component
 */
export default {
  components: {
    Navbar,
    Features,
    // Services,
    // About,
    // Pricing,
    Blog,
    Contact,
    Footer,
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    }
  }
};
</script>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/home-image.png') + ')', 'background-size': 'cover','background-position': 'center'}"
      >
      <!-- <section
        class="section bg-home height-100vh"
        id="home"
      > -->
<div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <!-- <h1 class="home-title">Inovative Solutions</h1> -->
                  <img src="@/assets/logo.png" style="width: 50vh; margin-bottom: -10vh; max-width: 100%;" alt="">
                  <h4 class="home-small-title">The key to growing your business</h4>
                  <p
                    class="padding-t-15 home-desc mx-auto home-small-title2"
                  >A solution for every problem</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <vue-particles class="position-relative" color="#FFF" style="height: 110%;"></vue-particles>

      </section>

<p id="about-us" style="visibility: hidden;" >asad</p>

<Features/>
<Blog />
<p id="contact-form" style="visibility: hidden;" >asad</p>

<Contact/>
     


      <!-- <Services /> -->
      <!-- <About /> -->
      <!-- <Pricing /> -->
      <Footer />
    </div>
  </div>
</template>

<style scoped>
.home-small-title
{
  /* background-color: rgba(97, 97, 97, 0.562); */
  background-color: #28418a;
  border-radius: 40px;
  height: 10%;
  width: 80%;
  padding-top: 1%;
  margin-left: 10%;
}
.home-small-title2
{
  /* background-color: rgba(97, 97, 97, 0.562); */
  background-color: #28418a;
  border-radius: 40px;
  height: 10%;
  width: 34%;
  padding-top: 1%;
  margin-left: 10%;
  color: white;
}
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
html{
   height: 100%;
   overflow-y: hidden;
}
</style>